import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { Color, ColorDtoDelekComponent, getEcommColors } from "api"
import {
  fetchUpholsteries,
  resetUpholsteries,
} from "components/shopFeatures/upholstery/upholsterySlice"
import { updatePriceAndURL } from "components/shopFeatures/wizard/wizardSlice"
import { createAsyncAppThunk } from "store"

const name = "color"

export type ColorState = {
  colors: ColorDtoDelekComponent[]
  selectedColorCode: Color["code"]
  loading: boolean
}

const initialState: ColorState = {
  colors: [],
  selectedColorCode: "",
  loading: true,
}

export const fetchColors = createAsyncAppThunk(
  `${name}/fetchColors`,
  async (detailingCode: string, { dispatch, getState }) => {
    const {
      data: { body: colors },
    } = await getEcommColors(detailingCode)

    const selected = getState().color.selectedColorCode
    const showOnlyStock = getState().wizard.showOnlyStock

    let colorToSelect = selected
    if (selected) {
      const selectedColor = colors.find((c) => c.details.code === selected)
      if (!selectedColor || !selectedColor.details.inStock) {
        // Selected color is not in stock
        const inStockColor = colors.find((c) => c.details.inStock)
        if (inStockColor) {
          colorToSelect = inStockColor.details.code
        } else {
          colorToSelect = showOnlyStock ? "" : colors[0]?.details.code ?? ""
        }
      }
    } else {
      // No selected color
      const inStockColor = colors.find((c) => c.details.inStock)
      if (inStockColor) {
        colorToSelect = inStockColor.details.code
      } else {
        colorToSelect = showOnlyStock ? "" : colors[0]?.details.code ?? ""
      }
    }
    dispatch(setSelectedColor(colorToSelect))
    return colors
  }
)

export const setSelectedColor = createAsyncAppThunk(
  `${name}/setSelectedColor`,
  (colorCode: string, { getState, dispatch }) => {
    dispatch(updatePriceAndURL())
    if (colorCode) {
      const { selectedDetailingCode: detailingCode } = getState().detailing
      dispatch(fetchUpholsteries({ detailingCode, colorCode }))
    } else {
      dispatch(resetUpholsteries())
    }
  }
)

const color = createSlice({
  name,
  initialState,
  reducers: {
    setLoading(state, { payload }: PayloadAction<ColorState["loading"]>) {
      state.loading = payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchColors.fulfilled, (state, { payload }) => {
        state.colors = payload
      })
      .addCase(setSelectedColor.pending, (state, { meta }) => {
        state.selectedColorCode = meta.arg
      })
  },
})

export const { setLoading } = color.actions

export default color.reducer
